export const SET_SHOW_SEARCH_BAR = 'SET_SHOW_SEARCH_BAR';

const setShowSearchBar = (state: boolean) => ({
  type: SET_SHOW_SEARCH_BAR,
  state,
});

export default { setShowSearchBar };
